import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ApplicationListing from "./components/ApplicationListing/ApplicationListing";
import JobApplicationDetails from "./components/JobApplicationDetails/JobApplicationDetails";
import { JobApplication } from "../../Entities/JobApplication";
import "./index.scss";

const ApplicationDetailsPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get("applicationId") || null;
  const jobPostId = searchParams.get("jobId") || null;

  const [selectedApplication, setSelectedApplication] =
    useState<JobApplication | null>(null);

  useEffect(() => {
    if (!applicationId || !jobPostId) {
      navigate(-1);
      return;
    }
  }, [applicationId, jobPostId, navigate]);

  if (!applicationId || !jobPostId) {
    return null;
  }

  return (
    <section className="application-details-page">
      <div className="application-details-page-side-bar">
        <ApplicationListing
          applicationId={applicationId}
          selectedApplication={selectedApplication}
          setSelectedApplication={setSelectedApplication}
        />
      </div>
      <div className="application-details-page-content">
        <JobApplicationDetails
          applicationId={applicationId}
          jobPostId={jobPostId}
          setSelectedApplication={setSelectedApplication}
          selectedApplication={selectedApplication}
        />
      </div>
    </section>
  );
};

export default ApplicationDetailsPage;
